/** UI/pricing keys used by booking wizard and pricing_experience_multipliers */
export const UI_EXPERIENCE_LEVELS = ['certified', 'distinguished', 'elite'];

/** photographer_profiles.experience_level (DB enum) → UI/pricing key */
export const DB_TO_UI_EXPERIENCE_LEVEL = {
  beginner: 'certified',
  intermediate: 'distinguished',
  advanced: 'distinguished',
  expert: 'elite',
};

/** UI/pricing key → photographer_profiles.experience_level (DB enum) */
export const UI_TO_DB_EXPERIENCE_LEVEL = {
  certified: 'beginner',
  distinguished: 'intermediate',
  elite: 'expert',
};

export const UI_EXPERIENCE_LEVEL_LABELS_AR = {
  certified: 'معتمد',
  distinguished: 'مميز',
  elite: 'نخبة',
};

/**
 * Normalize any experience level (DB enum, UI key, or Arabic label) to UI/pricing key.
 * @returns {'certified'|'distinguished'|'elite'|null}
 */
export function normalizeExperienceLevelToUi(level) {
  if (level == null || level === '') return null;
  const trimmed = String(level).trim();
  if (!trimmed) return null;

  if (UI_EXPERIENCE_LEVELS.includes(trimmed)) return trimmed;

  const fromDb = DB_TO_UI_EXPERIENCE_LEVEL[trimmed];
  if (fromDb) return fromDb;

  if (trimmed.includes('نخبة')) return 'elite';
  if (trimmed.includes('مميز')) return 'distinguished';
  if (trimmed.includes('معتمد')) return 'certified';

  return null;
}

/** Normalize to DB enum value (beginner | intermediate | expert). */
export function normalizeExperienceLevelToDb(level) {
  const ui = normalizeExperienceLevelToUi(level);
  if (!ui) return null;
  return UI_TO_DB_EXPERIENCE_LEVEL[ui] || null;
}

/** Arabic display label from any raw level key. */
export function getExperienceLevelLabelAr(level, fallbackUi = 'certified') {
  const ui = normalizeExperienceLevelToUi(level) || fallbackUi;
  return UI_EXPERIENCE_LEVEL_LABELS_AR[ui] || 'معتمد';
}

/** Resolve UI key, Arabic label, and DB enum from any raw level. */
export function resolveExperienceLevel(level, fallbackUi = 'certified') {
  const ui = normalizeExperienceLevelToUi(level) || fallbackUi;
  return {
    ui,
    labelAr: UI_EXPERIENCE_LEVEL_LABELS_AR[ui] || 'معتمد',
    db: UI_TO_DB_EXPERIENCE_LEVEL[ui] || 'beginner',
  };
}
